import styled from 'styled-components';
import { DetailDrawer } from '../../../components/General/DetailDrawer';

export const ChatWrapper = styled(DetailDrawer)`
    display: flex;
    flex-direction: column;
`;
